<div class="container" >
  <div class="row">
      <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12">
          <div class="si-jounral-container clearfix">
              <div class="si-jounralDtails-col">                   
                  <div id="jounralView" class="jounral-container">                            
                  <!-- jounral 404 Start --> 
              <section class="jounral_404" style="background-image:url('assets/images/404.png')">
              <div class="text_center">
              <i class="sprite sprite-error"></i>
              <p><strong> Oops! </strong> Something went wrong.</p>
              <a  class="go_btn" (click)="reload_page()">Reload page</a>
              </div>
              </section>                           
                   
                   </div>
                  </div>
              </div>
         </div>
   </div>
</div>
